import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c66e835"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-token-cart-item"
}
const _hoisted_2 = { class: "m-token-cart-item__image" }
const _hoisted_3 = { class: "m-token-cart-item__details" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "m-token-cart-item__details__price" }
const _hoisted_6 = { class: "m-token-cart-item__quantity" }
const _hoisted_7 = {
  key: 1,
  class: "token-cart-skeleton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_m_token_cart_delete = _resolveComponent("m-token-cart-delete")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_LazyImage, {
            src: _ctx.product.featured_image
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: _ctx.product.url,
            class: "m-token-cart-item__details__title h4"
          }, _toDisplayString(_ctx.product.title), 9, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.product.formattedPrice), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString(_ctx.quantity), 1),
          _createVNode(_component_m_token_cart_delete)
        ]),
        _createElementVNode("div", null, _toDisplayString(_ctx.totalFormattedPrice), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7))
}